// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__fhlTB","content":"footer_content__dtDQ+","links":"footer_links__NZiFs","legalLinks":"footer_legalLinks__07ayP","tile-wrapper":"footer_tile-wrapper__WRyck"};